import React from 'react';
import { Accordion } from 'semantic-ui-react';
import ModifierSetBasic from './ModifierSetBasic';
import { ModifierSetPropType } from '../../../../../services/proptypes';
var defaultProps = {
  displayZeroCostModifierPrices: false
};
export default function ModifierSetsBasic(_ref) {
  var modifierSets = _ref.modifierSets,
    displayZeroCostModifierPrices = _ref.displayZeroCostModifierPrices;
  var panels = [{
    key: 'addons',
    title: 'Options',
    content: {
      content: /*#__PURE__*/React.createElement(React.Fragment, null, modifierSets.map(function (_ref2) {
        var modifierSetId = _ref2._id;
        return /*#__PURE__*/React.createElement(ModifierSetBasic, {
          modifierSetId: modifierSetId,
          key: modifierSetId,
          displayZeroCostModifierPrices: displayZeroCostModifierPrices
        });
      }))
    }
  }];
  return modifierSets.length > 0 && /*#__PURE__*/React.createElement(Accordion, {
    panels: panels,
    className: "fcfm-modifier-sets"
  });
}
ModifierSetsBasic.defaultProps = defaultProps;